import pako from 'pako';
import { LevelData } from '../data/levelData';
import { TileIndex } from '../types';

interface EncodedLevel {
  w: number;      // width
  h: number;      // height
  t: number[];    // tiles (flattened 2D array)
  n: string;      // name
  i?: string;     // hint (optional)
}

export function encodeLevel(level: LevelData): string {
  const data: EncodedLevel = {
    w: level.tiles[0].length,
    h: level.tiles.length,
    t: level.tiles.flat(),
    n: level.name,
    ...(level.hint && { i: level.hint })
  };
  const compressed = pako.deflate(JSON.stringify(data));
  // Convert to base64url (URL-safe base64)
  return btoa(String.fromCharCode(...compressed))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
}

export function decodeLevel(encoded: string): LevelData {
  // Convert from base64url to regular base64
  const base64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
  const binary = atob(base64);
  const bytes = new Uint8Array([...binary].map(c => c.charCodeAt(0)));
  const data: EncodedLevel = JSON.parse(pako.inflate(bytes, { to: 'string' }));

  // Reconstruct 2D array from flattened tiles
  const tiles: TileIndex[][] = [];
  for (let row = 0; row < data.h; row++) {
    tiles.push(data.t.slice(row * data.w, (row + 1) * data.w) as TileIndex[]);
  }

  return {
    name: data.n,
    tiles,
    hint: data.i
  };
}

export function getCustomLevelFromURL(): LevelData | null {
  const params = new URLSearchParams(window.location.search);
  const encoded = params.get('level');
  if (!encoded) return null;

  try {
    return decodeLevel(encoded);
  } catch (error) {
    console.error('Failed to decode level from URL:', error);
    return null;
  }
}

export function generateShareURL(level: LevelData): string {
  const encoded = encodeLevel(level);
  return `${window.location.origin}${window.location.pathname}?level=${encoded}`;
}
